import { useEffect, useRef } from 'react';
import { useEventContextMenu } from '../../../store/eventContextMenuStore';
import { buildEventContextMenuItems } from '../../../domain/fullCalendar/fullCalendarUseCase';
import styles from './EventContextMenu.module.css';
import Button from '../../atoms/Button/Button';

/**
 * Menu contextuel pour les événements du calendrier.
 * État d'affichage (isOpen, x, y, event, calendar) lu depuis le store.
 * @param {object} props
 * @param {(item: import('../../../domain/fullCalendar/fullCalendarUseCase').TimelineEventContextMenuItem, event: import('@fullcalendar/core').EventApi) => void} props.onSelect
 * @returns {JSX.Element | null}
 */
function EventContextMenu({ onSelect }) {
  const menuRef = useRef(null);
  const {
    isOpen, x, y, event, closeContextMenu,
  } = useEventContextMenu();

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleClickOutside = (/** @type {MouseEvent} */ e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        closeContextMenu();
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen, closeContextMenu]);

  if (!isOpen || !event) return null;

  const items = buildEventContextMenuItems(event);
  if (items.length === 0) return null;

  return (
    <div
      ref={menuRef}
      className={styles.menu}
      style={{ left: x, top: y }}
    >
      {items.map((item) => (
        <Button
          key={item.id}
          onClick={() => {
            onSelect(item, event);
            closeContextMenu();
          }}
          color="no-background"
        >
          {item.lib}
        </Button>
      ))}
    </div>
  );
}

export default EventContextMenu;
